import React, { FunctionComponent } from "react";
import {
  Code,
  CodeProps,
} from "@chakra-ui/react";

import { CostsStrategy } from "./types";
import { useIntl } from "react-intl";


interface IProps extends CodeProps {
  strategy: CostsStrategy;
  costs: number[];
  bests?: CostsStrategy[];
}


const EstimatedCosts: FunctionComponent<IProps> = ({
  strategy,
  costs,
  bests,
  ...rest
}) => {
  const intl = useIntl();

  return (
    <>
      {costs.map((cost, ix) => (
        <>
          <Code
            ml={3}
            fontSize={"xs"}
            colorScheme={bests && bests[ix] === strategy ? "enposol" : undefined}
            variant={bests && bests[ix] === strategy ? "solid" : "subtle"}
            title={intl.formatMessage({
              id: "estimation__cost_day",
              defaultMessage: "Estimated cost of energies of day {day}: {cost}€ {appendix}",
            }, {
              day: ix + 1,
              cost: Math.round(cost),
              appendix: !bests || bests[ix] !== strategy ? "" : intl.formatMessage({
                id: "estimation__best_strategy",
                defaultMessage: "(Best strategy)",
              }),
            })}
          >
            {Math.round(cost)}
          </Code>
        </>
      ))}
    </>
  )
}

export default EstimatedCosts;
